import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import { format } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as Actions from '../actions/imstat';
import MessageDialog from '../components/MessageDialog';

import { isMobile } from '../utils/MobileCheck';

import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IFetchTrainingProgressDataParam,
} from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import { Routes, Screens } from '../utils/Routes';
const ITEM_HEIGHT = 48;

export enum GroupTrainingTypes {
	ONGOING,
	RESULT,
}

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		groupTrainingTitle: {
			color: theme.palette.primary.main,
			cursor: 'pointer',
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
		root: {
			flexGrow: 1,
			padding: 24,
		},
	});

interface IState {
	functionMenuAnchorEl?: HTMLElement;
	openErrorJukouMessageDialog: boolean;
	openErrorJukouMobileMessageDialog: boolean;
	openErrorJukouStatusSinseiMessageDialog: boolean;
	width: number;
}

/**
 * 実施状況カードコンポーネント
 */
class GroupTrainingCard extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			openErrorJukouMessageDialog: false,
			openErrorJukouMobileMessageDialog: false,
			openErrorJukouStatusSinseiMessageDialog: false,
			width: 0,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	/**
	 * 日付書式フォーマット
	 * @param date 対象日付
	 */
	public getFormatedDate(date: any) {
		if (!date) {
			return null;
		}
		const d = new Date(
			date.year,
			date.monthValue - 1,
			date.dayOfMonth,
			date.hour,
			date.minute
		);
		return format(d, 'yyyy/MM/dd HH:mm');
	}

	public render() {
		const { functionMenuAnchorEl } = this.state;

		if (this.props.iOnGoingData) {
			const { classes, iOnGoingData } = this.props;
			const re = /^\d+\/(\d+)$/;
			let result = re.exec(iOnGoingData.enquete);
			const enableQuestionnaire =
				result &&
				parseInt(result[1], 10) !== 0 &&
				iOnGoingData.aplType !== '0'
					? true
					: false;
			result = re.exec(iOnGoingData.kadai);
			const enableExercise =
				result &&
				parseInt(result[1], 10) !== 0 &&
				iOnGoingData.aplType !== '0'
					? true
					: false;
			let period = iOnGoingData.jissiKikan;
			if (period && period.indexOf('～') !== -1) {
				period = period.replace(
					'～',
					i18n.t('～', {
						ns: 'force',
					})
				);
			}
			return (
				<>
					<Card className={classes.card}>
						<CardContent className={classes.content}>
							<Tooltip
								title={iOnGoingData.careerTitle}
								placement="top-start"
							>
								<Typography
									variant="h5"
									component="h2"
									className={classes.groupTrainingTitle}
									onClick={this.handleShowDetailDialog}
								>
									{iOnGoingData.careerTitle}
								</Typography>
							</Tooltip>
							<Typography component="p">
								{(() => {
									const status = i18n.t(iOnGoingData.status, {
										ns: 'force',
									});
									if (
										!isMobile() &&
										['0', '1', '2', '3', '4'].indexOf(
											iOnGoingData.aplType
										) !== -1
									) {
										return (
											<span>
												{i18n.t(
													'GroupTrainingCard_0001'
												)}
												:{' '}
												<span
													className={
														this.props.classes.link
													}
													onClick={
														this
															.showApplicationStatus
													}
												>
													{status}
												</span>
											</span>
										);
									} else {
										return (
											<span>
												{i18n.t(
													'GroupTrainingCard_0001'
												)}
												: {status}
											</span>
										);
									}
								})()}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0002')}: {period}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0003')}:{' '}
								{this.getFormatedDate(
									iOnGoingData.jissiStartDateODT
								)}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0004')}:{' '}
								{this.getFormatedDate(
									iOnGoingData.jissiEndDateODT
								)}
							</Typography>
						</CardContent>
						<CardActions>
							{enableQuestionnaire && (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.showQuestionnaire}
									style={{
										fontSize: '0.562rem',
										paddingLeft: 2,
										paddingRight: 2,
									}}
								>
									{i18n.t('GroupTrainingCard_0005')}
								</Button>
							)}
							{enableExercise && !isMobile() && (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.showExercise}
									style={{ fontSize: '0.625rem' }}
								>
									{i18n.t('GroupTrainingCard_0006')}
								</Button>
							)}
							{isMobile() &&
								(iOnGoingData.appChangeOkFlg ||
									iOnGoingData.appResultOkFlg ||
									iOnGoingData.lecCancelOkFlg ||
									iOnGoingData.appCancelOkFlg) && (
									<IconButton onClick={this.handleOpenMenu}>
										<MenuIcon />
									</IconButton>
								)}
							{!isMobile() && (
								<IconButton onClick={this.handleOpenMenu}>
									<MenuIcon />
								</IconButton>
							)}
							<Menu
								anchorEl={functionMenuAnchorEl}
								open={Boolean(functionMenuAnchorEl)}
								onClose={this.handleCloseMenu}
								anchorOrigin={{
									horizontal: 'center',
									vertical: 'bottom',
								}}
								transformOrigin={{
									horizontal: 'center',
									vertical: 'top',
								}}
								getContentAnchorEl={undefined}
								PaperProps={{
									style: {
										maxHeight: ITEM_HEIGHT * 4.5,
										width: 200,
									},
								}}
							>
								{!isMobile() && (
									<MenuItem onClick={this.showDetail}>
										{i18n.t('GroupTrainingCard_0007')}
									</MenuItem>
								)}
								{iOnGoingData.appChangeOkFlg && (
									<MenuItem
										onClick={this.showChangeApplication}
									>
										{i18n.t('GroupTrainingCard_0008')}
									</MenuItem>
								)}
								{iOnGoingData.appResultOkFlg && (
									<MenuItem
										onClick={this.showActResultApplication}
									>
										{i18n.t('GroupTrainingCard_0009')}
									</MenuItem>
								)}
								{iOnGoingData.lecCancelOkFlg && (
									<MenuItem onClick={this.showStCancel}>
										{i18n.t('GroupTrainingCard_0010')}
									</MenuItem>
								)}
								{iOnGoingData.appCancelOkFlg && (
									<MenuItem
										onClick={this.showCancelApplication}
									>
										{i18n.t('GroupTrainingCard_0011')}
									</MenuItem>
								)}
							</Menu>
						</CardActions>
					</Card>
					<MessageDialog
						open={
							this.state.openErrorJukouStatusSinseiMessageDialog
						}
						showCancelButton={false}
						title={i18n.t('GroupTrainingCard_0012')}
						contents={[{ content: 'LMCM_E_00677' }]}
						onClose={this.errorMessageJukouStatusSinseiDialogClose}
						onClickOk={
							this.errorMessageJukouStatusSinseiDialogClose
						}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMessageDialog}
						showCancelButton={false}
						title={i18n.t('GroupTrainingCard_0012')}
						contents={[{ content: 'LMCM_I_00634' }]}
						onClose={this.errorMessageJukouDialogClose}
						onClickOk={this.errorMessageJukouDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMobileMessageDialog}
						showCancelButton={false}
						title={i18n.t('GroupTrainingCard_0012')}
						contents={[{ content: 'LMCM_E_00678' }]}
						onClose={this.errorMessageJukouMobileDialogClose}
						onClickOk={this.errorMessageJukouMobileDialogClose}
					/>
				</>
			);
		} else if (this.props.IResultData) {
			const { classes, IResultData } = this.props;
			const re = /^\d+\/(\d+)$/;
			let result = re.exec(IResultData.enquete);
			const enableQuestionnaire =
				result &&
				parseInt(result[1], 10) !== 0 &&
				IResultData.aplType !== '0'
					? true
					: false;
			result = re.exec(IResultData.kadai);
			const enableExercise =
				result &&
				parseInt(result[1], 10) !== 0 &&
				IResultData.aplType !== '0'
					? true
					: false;
			let period = IResultData.jissiKikan;
			if (period && period.indexOf('～') !== -1) {
				period = period.replace(
					'～',
					i18n.t('～', {
						ns: 'force',
					})
				);
			}
			return (
				<>
					<Card className={classes.card}>
						<CardContent className={classes.content}>
							<Tooltip
								title={IResultData.careerTitle}
								placement="top-start"
							>
								<Typography
									variant="h5"
									component="h2"
									className={classes.groupTrainingTitle}
									onClick={this.handleShowDetailDialog}
								>
									{IResultData.careerTitle}
								</Typography>
							</Tooltip>
							<Typography component="p">
								{(() => {
									const status = i18n.t(IResultData.status, {
										ns: 'force',
									});
									if (
										!isMobile() &&
										['0', '1', '2', '3', '4'].indexOf(
											IResultData.aplType
										) !== -1
									) {
										return (
											<span>
												{i18n.t(
													'GroupTrainingCard_0001'
												)}
												:{' '}
												<span
													className={
														this.props.classes.link
													}
													onClick={
														this
															.showApplicationStatus
													}
												>
													{status}
												</span>
											</span>
										);
									} else {
										return (
											<span>
												{i18n.t(
													'GroupTrainingCard_0001'
												)}
												: {status}
											</span>
										);
									}
								})()}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0002')}: {period}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0003')}:{' '}
								{this.getFormatedDate(
									IResultData.jissiStartDateODT
								)}
							</Typography>
							<Typography component="p">
								{i18n.t('GroupTrainingCard_0004')}:{' '}
								{this.getFormatedDate(
									IResultData.jissiEndDateODT
								)}
							</Typography>
						</CardContent>
						<CardActions>
							{enableQuestionnaire && (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.showQuestionnaire}
									style={{
										fontSize: '0.562rem',
										paddingLeft: 2,
										paddingRight: 2,
									}}
								>
									{i18n.t('GroupTrainingCard_0005')}
								</Button>
							)}
							{enableExercise && !isMobile() && (
								<Button
									variant="contained"
									color="primary"
									size="small"
									onClick={this.showExercise}
									style={{ fontSize: '0.625rem' }}
								>
									{i18n.t('GroupTrainingCard_0006')}
								</Button>
							)}
							{!isMobile() && (
								<>
									<IconButton onClick={this.handleOpenMenu}>
										<MenuIcon />
									</IconButton>
									<Menu
										anchorEl={functionMenuAnchorEl}
										open={Boolean(functionMenuAnchorEl)}
										onClose={this.handleCloseMenu}
										anchorOrigin={{
											horizontal: 'center',
											vertical: 'bottom',
										}}
										transformOrigin={{
											horizontal: 'center',
											vertical: 'top',
										}}
										getContentAnchorEl={undefined}
										PaperProps={{
											style: {
												maxHeight: ITEM_HEIGHT * 4.5,
												width: 200,
											},
										}}
									>
										<MenuItem onClick={this.showDetail}>
											{i18n.t('GroupTrainingCard_0007')}
										</MenuItem>
										{IResultData.referenceOkFlg && (
											<MenuItem
												onClick={
													this.showActResultReference
												}
											>
												{i18n.t(
													'GroupTrainingCard_0013'
												)}
											</MenuItem>
										)}
										{IResultData.certificateDispFlg && (
											<MenuItem
												onClick={
													this.showComplCertificate
												}
											>
												{i18n.t(
													'GroupTrainingCard_0014'
												)}
											</MenuItem>
										)}
										{IResultData.retakeOkFlg && (
											<MenuItem onClick={this.showApply}>
												{i18n.t(
													'GroupTrainingCard_0015'
												)}
											</MenuItem>
										)}
									</Menu>
								</>
							)}
						</CardActions>
					</Card>
					<MessageDialog
						open={this.state.openErrorJukouMessageDialog}
						showCancelButton={false}
						title={i18n.t('GroupTrainingCard_0012')}
						contents={[{ content: 'LMCM_I_00634' }]}
						onClose={this.errorMessageJukouDialogClose}
						onClickOk={this.errorMessageJukouDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMobileMessageDialog}
						showCancelButton={false}
						title={i18n.t('GroupTrainingCard_0012')}
						contents={[{ content: 'LMCM_E_00678' }]}
						onClose={this.errorMessageJukouMobileDialogClose}
						onClickOk={this.errorMessageJukouMobileDialogClose}
					/>
				</>
			);
		}
		return;
	}

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: event.currentTarget });
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouDialogClose = () => {
		this.setState({ openErrorJukouMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouDialogOpen = () => {
		this.setState({ openErrorJukouMessageDialog: true });
	};

	/**
	 * モバイル時受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouMobileDialogClose = () => {
		this.setState({ openErrorJukouMobileMessageDialog: false });
	};

	/**
	 * モバイル時受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouMobileDialogOpen = () => {
		this.setState({ openErrorJukouMobileMessageDialog: true });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouStatusSinseiDialogClose = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: false });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouStatusSinseiDialogOpen = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: true });
	};

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected showDetail = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingとIResultどちらでも呼ばれる
		let careerID: string = '';
		if (this.props.iOnGoingData) {
			careerID = this.props.iOnGoingData.careerID;
		} else if (this.props.IResultData) {
			careerID = this.props.IResultData.careerID;
		}
		let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		this.props.pushHistory(to);

		this.setState({ functionMenuAnchorEl: undefined });
	};

	protected handleShowDetailDialog = (e: React.MouseEvent<HTMLElement>) => {
		let dataCareerID: string = '';
		if (this.props.iOnGoingData) {
			dataCareerID = this.props.iOnGoingData.careerID;
		} else if (this.props.IResultData) {
			dataCareerID = this.props.IResultData.careerID;
		}
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: dataCareerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: true,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected showChangeApplication = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingのみ呼ばれる
		if (this.props.iOnGoingData) {
			const cardData: Actions.IOnGoingGroupTraining = this.props
				.iOnGoingData;
			const { careerID, careerTypeID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:career_typeid/, `/${careerTypeID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultApplication = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.iOnGoingData) {
			const cardData: Actions.IOnGoingGroupTraining = this.props
				.iOnGoingData;
			const { careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:nittei_only_flg/, `/0`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultReference = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IResultGroupTraining = this.props
				.IResultData;
			const {
				careerID,
				classID,
				seq,
				imstatListStatusId,
				reasonCode,
			} = cardData;
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:seq/, `/${seq}`);
			const state = {
				careerID,
				classID,
				imstatListStatusId,
				reasonCode,
				seq,
			};
			this.props.pushHistoryState(to, state);
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showStCancel = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.iOnGoingData) {
			const cardData: Actions.IOnGoingGroupTraining = this.props
				.iOnGoingData;
			const { careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:curriculum_flg/, `/0`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showCancelApplication = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingのみ呼ばれる
		if (this.props.iOnGoingData) {
			const cardData: Actions.IOnGoingGroupTraining = this.props
				.iOnGoingData;
			const { aplType, careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:apl_type/, `/${aplType}`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * アンケート回答画面表示
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaire = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingとIResutlどちらでも呼ばれる
		let cardData: any;
		if (this.props.iOnGoingData) {
			cardData = this.props.iOnGoingData;
		} else if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID } = cardData;
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(pathname, {
			caller: window.location.pathname,
		});
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 進捗状況画面表示
	 * @param e イベントオブジェクト
	 */
	protected showTrainingProgress = (e: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.iOnGoingData) {
			cardData = this.props.iOnGoingData;
		}
		const { token, userAttr } = this.props;
		const { careerID, classID } = cardData;
		this.props.fetchTrainingProgressData(token, {
			careerID,
			classID,
			userAttr,
		});
	};

	/**
	 * 課題提出画面表示
	 * @param e イベントオブジェクト
	 */
	protected showExercise = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingとIResultどちらでも呼ばれる
		let cardData: any;
		if (this.props.iOnGoingData) {
			cardData = this.props.iOnGoingData;
		}
		if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID } = cardData;
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		const state = {
			caller: window.location.pathname,
			outOfPeriodFlg: cardData.outOfPeriodFlg,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 再申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApply = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IGroupTraining = this.props.IResultData;
			const { careerID } = cardData;
			const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
			const state = {
				caller: window.location.pathname,
				careerType: '0',
				targetCareerId: careerID,
			};
			this.props.pushHistoryState(to, state);
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected showComplCertificate = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IResultGroupTraining = this.props
				.IResultData;
			const { careerID } = cardData;
			const { userAttr } = this.props;

			let url =
				Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
			url = url + 'userId=' + userAttr.userId;
			url = url + '&locale=' + userAttr.locale;
			url = url + '&lang=' + userAttr.lang;
			url = url + '&careerID=' + careerID;
			url = url + '&accessType=10';
			window.open(url, '_blank');
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * テストアンケート履歴表示
	 * @param e イベントオブジェクト
	 */
	protected showHistory = (event: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.iOnGoingData) {
			cardData = this.props.iOnGoingData;
		} else if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID } = cardData;
		let to = Routes.getPath(Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApplicationStatus = (e: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.iOnGoingData) {
			cardData = this.props.iOnGoingData;
		} else if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID, aplType } = cardData;
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: aplType,
			careerID,
			classID,
			curriculumFlg: '0',
			setApplicationStatusDialog: true,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 進捗率の表示
	 * @param data propsのdata
	 */
	protected progress = (progress: any, createProgressLinkFlg: boolean) => {
		if (!progress) {
			return;
		}
		const progressBar: number = progress.slice(0, -1);
		if (createProgressLinkFlg) {
			return (
				<div
					style={{
						backgroundColor: '#dadada',
						borderRadius: '2px',
						cursor: 'pointer',
						display: 'inline-block',
						height: 20,
						width: '100%',
					}}
					onClick={this.showTrainingProgress}
				>
					<div
						style={{
							backgroundColor:
								progressBar > 66
									? '#85cc00'
									: progressBar > 33
									? '#ffbf00'
									: '#ff2e00',
							borderRadius: '2px',
							display: 'inline-block',
							height: '100%',
							transition: 'all .2s ease-out',
							width: `${progressBar}%`,
						}}
					>
						{progress}
					</div>
				</div>
			);
		} else {
			return <div style={{ height: 20 }}>---</div>;
		}
	};

	protected updateWindowDimensions = () => {
		this.setState({ width: window.innerWidth });
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchTrainingProgressData: (
		token: string,
		arg: IFetchTrainingProgressDataParam
	) => {
		const s = ScenarioFactory.createFetchTrainingProgressData(
			dispatch,
			token
		);
		s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface IGroupTrainingCardProps {
	iOnGoingData?: Actions.IOnGoingGroupTraining;
	IResultData?: Actions.IResultGroupTraining;
	type: GroupTrainingTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IGroupTrainingCardProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(GroupTrainingCard);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/GroupTrainingCard.tsx